export const preventValueChangeOnScroll = (e) => {
    const target = e.target;
    if (target.type === "number" && target === document.activeElement) {
        target.blur();
        window.requestAnimationFrame(() => target.focus());
    }
}